((app, ng) => {

    app.controller("editFundingSourceController", editFundingSourceController);

    function editFundingSourceController($mdDialog, fundingSourceApi) {
        const $ctrl = this;

        const close = (source) => {
            $mdDialog.hide(source);
        }

        const createFundingSource = (source) => {
            if (!!source.EstimatedAmount) {
                $ctrl.ui.saving = true;

                if (!!source.ActualAmount) {
                    source.ActualAmountUpdatedOn = new Date();
                }

                fundingSourceApi.createFundingSource(source).then(response => {
                    $ctrl.close({ evt: "FUNDING_SOURCE_CREATED", source: response });
                });
            }
        }

        const updateFundingSource = (source) => {
            if (!!source.Id && !!source.EstimatedAmount) {
                $ctrl.ui.saving = true;

                if ($ctrl.initialActualAmount !== source.ActualAmount) {
                    source.ActualAmountUpdatedOn = new Date();
                }

                fundingSourceApi.updateFundingSource(source.Id, source).then(() => {
                    $ctrl.close({ evt: "FUNDING_SOURCE_UPDATED", source: source });
                });
            }
        }

        const deleteFundingSource = (source) => {
            if (!!source.Id) {
                $ctrl.ui.saving = true;

                fundingSourceApi.deleteFundingSource(source.Id).then(() => {
                    $ctrl.close({ evt: "FUNDING_SOURCE_DELETED", source: source });
                });
            }
        }

        ng.extend($ctrl,
            {
                close,
                createFundingSource,
                updateFundingSource,
                deleteFundingSource,
            });

        $ctrl.$onInit = () => {
            $ctrl.ui = {
                saving: false,
            };

            if (!!$ctrl.source) {
                $ctrl.initialActualAmount = $ctrl.source.ActualAmount;
            }
        };
    }

})(window.app, window.angular);